<template>
	<div id="app" >
		<headern-nav />
		<router-view :key="key"/>
		<footer-nav />
	</div>
</template>
<script>
	import headernNav from '@/components/headern.vue'
	import footerNav from '@/components/footer.vue'
	export default {
		components: { headernNav,footerNav },
		computed:{
			key(){
				return this.$route.fullPath
			}
		}
	}
</script>
<style lang="scss">
	* {
	    -webkit-user-select: text;
	    outline: 0;
	    -webkit-tap-highlight-color: transparent;
	    box-sizing: border-box;
	}
	@media screen and (min-width: 1000px) {
		body{
			font-family: Microsoft Yahei, PingFang SC, Avenir, Segoe UI, Hiragino Sans GB, STHeiti, "Microsoft Sans Serif", WenQuanYi Micro Hei, sans-serif;
			margin: 0;
			color: #333;
			font-size: 14px;
		}
		.el-pagination {
		    color: #666666;
		    font-weight: 400;
		    font-size: 13px;
		}
		.el-pagination .btn-prev,
		.el-pagination .btn-next {
		    background-color: #FFFFFF !important;
		    border: 1px solid #E6E6E6 !important;
		    width: 67px !important;
		    height: 29px !important;
		    border-radius: 3px !important;
		    display: inline-flex;
		    justify-content: center;
		    align-items: center;
		    color: #666666 !important;
		}
		
		.el-pagination .btn-prev:disabled,
		.el-pagination .btn-next:disabled {
		    color: #C0C4CC !important;
		}
		
		.el-pagination .el-pager .number {
		    width: 29px !important;
		    height: 29px !important;
		    line-height: 29px !important;
		    text-align: center;
		    background-color: #FFFFFF !important;
		    border-radius: 3px !important;
		    border: 1px solid #E6E6E6;
		    color: #666666 !important;
		}
		
		.el-pagination.is-background .el-pager li:not(.disabled).active {
		    background-color: #D71418 !important;
		    color: #FFF !important;
		}
	}
	@media screen and (max-width: 999px) {
		body{
			font-family: Microsoft Yahei, PingFang SC, Avenir, Segoe UI, Hiragino Sans GB, STHeiti, "Microsoft Sans Serif", WenQuanYi Micro Hei, sans-serif;
			margin: 0;
			color: #333;
			font-size: 3.73333vw;
		}
		.el-pagination {
		    color: #666666;
		    font-weight: 400;
		    font-size: 3.46666vw;
		}
		.el-pagination .btn-prev,
		.el-pagination .btn-next {
		    background-color: #FFFFFF !important;
		    border: 1px solid #666 !important;
		    width: 18vw !important;
		    height: 8vw !important;
			display: inline-flex;
			justify-content: center;
			align-items: center;
		    border-radius: 3px !important;
		    color: #666 !important;
		}
		.el-pagination button, .el-pagination span{
			font-size: 3.2vw !important;
		}
		
		.el-pagination .btn-prev:disabled,
		.el-pagination .btn-next:disabled {
		    color: #C0C4CC !important;
			border: 1px solid #E6E6E6 !important;
		}
		
		.el-pagination .el-pager .number {
		    width: 8vw !important;
		    height: 8vw !important;
		    line-height: 8vw !important;
		    text-align: center;
		    background-color: #FFFFFF !important;
		    border-radius: 3px !important;
		    border: 1px solid #E6E6E6;
		    color: #666666 !important;
		}
		
		.el-pagination.is-background .el-pager li:not(.disabled).active {
		    background-color: #D71418 !important;
		    color: #FFF !important;
		}
	}
	.ellipsis {
	    text-overflow: ellipsis;
	    overflow: hidden;
	    display: -webkit-box;
	    word-break: break-all;
	    -webkit-box-orient: vertical;
	    line-clamp: 1;
	    -webkit-line-clamp: 1;
	}
	.ellipsis2 {
	    text-overflow: ellipsis;
	    overflow: hidden;
	    display: -webkit-box;
	    word-break: break-all;
	    -webkit-box-orient: vertical;
	    line-clamp: 2;
	    -webkit-line-clamp: 2;
	}
	.ellipsis3 {
	    text-overflow: ellipsis;
	    overflow: hidden;
	    display: -webkit-box;
	    word-break: break-all;
	    -webkit-box-orient: vertical;
	    line-clamp: 3;
	    -webkit-line-clamp: 3;
	}
	.flex{
		display: flex;
	}
	.align-center{
		align-items: center;
	}
	.justify-between{
		justify-content: space-between;
	}
	.justify-center{
		justify-content: center;
	}
	.flex-1{
		flex: 1;
	}
</style>